export default {
  aufHeroLabel: 'Aufenthalt im Alpenhof',
  aufHeroTitle: 'Mehr als ein Bett.\nEin Wohlfühl-\nErlebnis.',
  aufHeroText: 'Vom liebevoll zubereiteten Frühstück bis zur ruhigen Stunde im Garten – wir machen Ihren Aufenthalt zu mehr als einer Übernachtung.',

  aufBreakfastTitle: 'Ein Frühstück, das den Tag prägt',
  aufBreakfastText: 'Frische, regionale Produkte, liebevoll arrangiert – unser Frühstück ist eine kulinarische Einstimmung in den Tag.',
  aufCard1Title: 'Bio & Regional',
  aufCard1Text: 'Bio-Produkte der Andechser Molkerei, Brot vom besten Bio-Bäcker Europas und weitere hochwertige Zutaten.',
  aufCard2Title: 'Auswahl & Vielfalt',
  aufCard2Text: 'Vom klassischen Müsli bis zum warmen Frühstücksei – Sie wählen, wie der Tag beginnen soll.',
  aufCard3Title: 'Persönlicher Service',
  aufCard3Text: 'Sonderwünsche? Glutenfrei? Vegan? Wir gehen auf Ihre Bedürfnisse ein.',

  aufStayTitle: 'Was Ihren Aufenthalt besonders macht',
  aufStayText: 'Kleine Details mit großer Wirkung – damit Sie sich rundum wohlfühlen.',
  aufHighlight1Title: 'Garten & Natur',
  aufHighlight1Text: 'Unser Garten lädt im Sommer zum Verweilen ein – ein grüner Rückzugsort mitten im Würmtal.',
  aufHighlight2Title: 'Gemütlichkeit',
  aufHighlight2Text: 'Kachelofenstube, Bibliothek und Sitzecken – überall im Haus finden Sie Ihren Lieblingsplatz.',
  aufHighlight3Title: 'Persönliche Betreuung',
  aufHighlight3Text: 'Wir kennen unsere Gäste – und freuen uns, wenn Sie wiederkommen. Klein, familiär, zugewandt.',
  aufHighlight4Title: 'Beste Lage',
  aufHighlight4Text: 'Zwischen München, Starnberger See und den Alpen – als Ausgangspunkt für viele Tage Bayern.',

  aufInfoTitle: 'Praktische Informationen',
  aufInfoSubtitle: 'Damit Sie sich keine Gedanken machen müssen.',
  aufInfo1Title: 'Check-in & Check-out',
  aufInfo1In: 'ab 15:00 Uhr',
  aufInfo1Out: 'bis 12:00 Uhr',
  aufInfo1Note: 'Frühere oder spätere Zeiten gerne auf Anfrage.',
  aufInfo2Title: 'Frühstückszeiten',
  aufInfo2Weekday: '7:00 – 10:00 Uhr',
  aufInfo2Weekend: '8:00 – 11:00 Uhr',
  aufInfo2Note: 'An Feiertagen wie am Wochenende.',
  aufInfo3Title: 'Parkplätze',
  aufInfo3Text: 'Kostenlose Parkplätze direkt am Hotel.',
  aufInfo3Note: 'Keine Reservierung nötig.',
  aufInfo4Title: 'WLAN',
  aufInfo4Text: 'Kostenfreies WLAN im gesamten Haus.',
  aufInfo4Note: 'Zugangsdaten an der Rezeption.',

  aufGalleryTitle: 'Einblicke ins Haus',
  aufGalleryText: 'Ein paar Eindrücke, die mehr sagen als jede Beschreibung.',

  aufCtaLabel: 'Bereit zu buchen?',
  aufCtaTitle: 'Ihr Aufenthalt beginnt mit einer Anfrage.',
  aufCtaText: 'Prüfen Sie die Verfügbarkeit und sichern Sie sich Ihren Lieblingstermin – wir freuen uns auf Sie.',
  aufCtaButton: 'Verfügbarkeit prüfen',
};
